import router from './router'
let host = 'dev.alarmplan.ru'
let socketPort = '8888'
if (process.env.NODE_ENV === 'stages') {
  host = 'dev.alarmplan.ru'
  socketPort = '8886'
}
if (process.env.NODE_ENV === 'production') {
  host = 'alarmplan.ru'
}
export const apiDomain = 'https://' + host + '/'
export const storageUrl = 'https://' + host
export const apiVersion = 'api/'
export const loginUrl = apiDomain + apiVersion + 'login'
export const remindEmailUrl = apiDomain + apiVersion + 'remind/email'
export const resetPasswordUrl = apiDomain + apiVersion + 'reset/email'
export const userUrl = apiDomain + apiVersion + 'user'
export const graphQlUrl = apiDomain + 'graphql'
export const exportUrl = apiDomain + apiVersion + 'orders/export-to-excel'
export const socketUrl = host + ':' + socketPort
export const yandexGeoCodeApiKey = 'e9b992f7-8b3d-4557-938b-15e79ea38fa7'

export const getHeader = function () {
  let authUser = null
  if (window.localStorage.getItem('authUser')) {
    authUser = JSON.parse(window.localStorage.getItem('authUser'))
  } else {
    authUser = JSON.parse(window.sessionStorage.getItem('authUser'))
  }

  if (authUser) {
    const headers = {
      'Accept': 'application/json',
      'X-Api-Token': authUser.access_token
    }
    return headers
  } else {
    return false
  }
}
export const getAuthUser = function () {
  let authUser = null
  if (window.localStorage.getItem('authUser')) {
    authUser = JSON.parse(window.localStorage.getItem('authUser'))
  } else {
    authUser = JSON.parse(window.sessionStorage.getItem('authUser'))
  }

  return authUser
}
export const logout = function () {
  window.localStorage.removeItem('authUser')
  window.sessionStorage.removeItem('authUser')
  router.push({name: 'Auth'})
}



// WEBPACK FOOTER //
// ./src/config.js